/**
 * Inline empty-state shown in content pickers (track / car) when the hub's
 * content mirror holds nothing to pick from. Replaces the old free-text
 * fallback input — typing a raw folder name that the hub can't resolve was a
 * footgun, so we tell the operator to upload content instead. Compact enough
 * to sit where the form field used to be. Surfaces any already-stored value so
 * editing an existing event doesn't silently hide its configured content.
 */
interface NoContentNoticeProps {
  message: string;
  /** Currently-stored value to surface (edit mode), if any. */
  currentValue?: string;
}

export function NoContentNotice({ message, currentValue }: NoContentNoticeProps) {
  return (
    <div className="flex items-start gap-2 rounded-lg border border-dashed border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-500">
      <svg
        className="h-4 w-4 mt-0.5 flex-shrink-0 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span>
        {message}
        {currentValue && (
          <span className="block text-xs text-gray-400 mt-0.5">
            Currently set to{" "}
            <span className="font-medium text-gray-600">{currentValue}</span>
          </span>
        )}
      </span>
    </div>
  );
}
